import { BinType, friendlyName, isCustomBinDimension, isCustomDimension, isCustomSqlDimension, } from './field';
export const isAdditionalMetric = (value) => value?.table &&
    value?.name &&
    !value?.fieldType &&
    !isCustomDimension(value);
export const hasFormatOptions = (value) => !!value.formatOptions;
export const getCustomMetricDimensionId = (metric) => `${metric.table}_${metric.baseDimensionName}`;
export const getAdditionalMetricLabel = (item) => `${friendlyName(item.table)} ${item.label}`;
export const countCustomDimensionsInMetricQuery = (metricQuery) => ({
    numFixedWidthBinCustomDimensions: metricQuery.customDimensions?.filter((dimension) => isCustomBinDimension(dimension) &&
        dimension.binType === BinType.FIXED_NUMBER).length || 0,
    numFixedBinsBinCustomDimensions: metricQuery.customDimensions?.filter((dimension) => isCustomBinDimension(dimension) &&
        dimension.binType === BinType.FIXED_WIDTH).length || 0,
    numCustomRangeBinCustomDimensions: metricQuery.customDimensions?.filter((dimension) => isCustomBinDimension(dimension) &&
        dimension.binType === BinType.CUSTOM_RANGE).length || 0,
    numCustomSqlDimensions: metricQuery.customDimensions?.filter((dimension) => isCustomSqlDimension(dimension)).length || 0,
});
export const hasCustomBinDimension = (metricQuery) => metricQuery?.customDimensions &&
    metricQuery.customDimensions.some((dimension) => isCustomBinDimension(dimension));
//# sourceMappingURL=metricQuery.js.map